// extracted by mini-css-extract-plugin
module.exports = {"sidebar-section":"style_sidebar-section__Nnk_A"};